export const PRODUCT_NAME = "Red Fort Capital Loan Pulse";
export const PRODUCT_SHORT = "Loan Pulse";
